import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=465e396e&scoped=true&"
import script from "./MyReports.vue?vue&type=script&lang=js&"
export * from "./MyReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e396e",
  null
  
)

export default component.exports